import gql from 'graphql-tag';

export const cardGroupCreate = gql`
  mutation cardGroupCreate($input: CardGroupCreateInput!) {
    cardGroupCreate(input: $input) {
      card_group {
        id
      }
    }
  }
`;

export const cardGroupUpdate = gql`
  mutation cardGroupUpdate($input: CardGroupUpdateInput!) {
    cardGroupUpdate(input: $input) {
      card_group {
        id
      }
    }
  }
`;

export const cardGroupsDelete = gql`
  mutation cardGroupsDelete($input: CardGroupsDeleteInput!) {
    cardGroupsDelete(input: $input) {
      success
    }
  }
`;
